import React from 'react'
import SpainTemplateDefault from 'src/components/template/es'

const annotations = [
  {
    startSecs: '0',
    endSecs: '6.2',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/calle-13/annotations/ChicagoPD_logo.png',
  },
  {
    startSecs: '6.3',
    endSecs: '14.2',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/calle-13/annotations/Magnum_logo.png',
  },
  {
    startSecs: '14.3',
    endSecs: '19.2',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/calle-13/annotations/LaForense_logo.png',
  },
  {
    startSecs: '19.3',
    endSecs: '25.1',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/calle-13/annotations/Interrogation_logo.png',
  },
  {
    startSecs: '25.2',
    endSecs: '40.0',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/calle-13/annotations/Ley&Orden_logo.png',
  },
]

const pageTitle = 'SERIES INTERNACIONALES DE ACCIÓN Y FICCIÓN'
const pageDescription =
  'Ver Movistar Series en directo y bajo demanda. Fubo es un servicio de TV por Internet que ofrece canales de televisión con programas de entretenimiento en directo y los eventos deportivos más prestigiosos del mundo. El servicio ofrece acceso a canales nacionales y locales a través de TV, tablets, dispositivos móviles y portátiles.'

export default (props) => {
  return (
    <SpainTemplateDefault
      location={props.location}
      lang="es"
      market="spain"
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      video="https://assets.fubo.tv/marketing/lp/videos/compressed/Calle13_LP_30s.mp4"
      title="CALLE 13 EN DIRECTO Y A LA CARTA"
      subtitle="Desde solo 3,99€/mes"
      annotations={annotations}
    />
  )
}
